import { BehaviorSubject } from 'rxjs';

const cartSubject = new BehaviorSubject<{ [key: string]: any }>({});

export const UnifiedCartDataService = {
  setCartInfo: (lob: string, cartInfo: any, errorStatus: boolean) => {
    const currentCartInfo = cartSubject.getValue();
    cartSubject.next({
      ...currentCartInfo,
      [lob]: { cartInfo, errorStatus },
    });
  },
  getCartInfo: (): any => cartSubject.getValue(),
};
